import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=b449aeb2&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
import style0 from "@/static/style.module.css?vue&type=style&index=0&id=b449aeb2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b449aeb2",
  null
  
)

export default component.exports